import React, { Fragment } from "react";
import { arrayOf, bool, number, shape, string } from "prop-types";

import * as S from "./styled";

const MostViewedListing = ({ listing }) => (
  <S.MostViewedListingWrapper>
    <S.ImageBox>
      <S.ImageLink
        data-gtm-header-listing-id={listing.id}
        data-gtm-header-listing-type={listing.type}
        href={listing.link}
      >
        <S.Image alt={listing.title} src={listing.img} />
      </S.ImageLink>
    </S.ImageBox>
    <S.Content>
      <S.TitleLink
        data-gtm-header-listing-id={listing.id}
        data-gtm-header-listing-type={listing.type}
        href={listing.link}
      >
        {listing.title}
      </S.TitleLink>
      <div>
        {listing.has_rental_period_prices ? (
          "Price varies"
        ) : (
          <>
            {listing.has_price_delta ? (
              <span>{listing.price_delta < 0 ? "↓" : "↑"}</span>
            ) : null}
            <S.Price>{listing.price}</S.Price>
            <S.For>{listing.is_rental ? "for rent" : "for sale"}</S.For>
          </>
        )}
        {listing.is_rental && listing.has_no_fee ? (
          <S.NoFeeBadge>No Fee</S.NoFeeBadge>
        ) : null}
      </div>

      <div>
        {listing.amenities?.map((item, index, arr) => (
          <Fragment key={`${item + index}`}>
            <span>{item}</span>
            {index < arr.length - 1 ? <S.Bullet>•</S.Bullet> : null}
          </Fragment>
        ))}
      </div>
      {listing.has_unittype_label && listing.has_interesting_area ? (
        <div>
          {listing.unittype_label} in{" "}
          <S.Link href={listing.area_link}>{listing.area_name}</S.Link>
        </div>
      ) : null}
      {listing.is_featured ? (
        <>
          <div>
            <S.Featured>featured</S.Featured>
          </div>
          <S.ListedBy>Listed by {listing.source_label}</S.ListedBy>
        </>
      ) : null}
    </S.Content>
  </S.MostViewedListingWrapper>
);

MostViewedListing.propTypes = {
  listing: shape({
    id: number,
    type: string,
    title: string,
    link: string,
    img: string,
    has_rental_period_prices: bool,
    has_price_delta: bool,
    price_delta: number,
    price: string,
    is_rental: bool,
    has_no_fee: bool,
    amenities: arrayOf(string),
    has_unittype_label: bool,
    unittype_label: string,
    area_name: string,
    area_link: string,
    has_interesting_area: bool,
    is_featured: bool,
    source_label: string
  })
};

MostViewedListing.defaultProps = {
  listing: {}
};

export default MostViewedListing;
